import React, { forwardRef, type ForwardRefExoticComponent, type RefAttributes } from 'react';
import { useClassNameMapper } from 'react-bootstrap';
import { FormFeedbackType } from '../../../helpers/form/FormFieldFeedback/enums';
import type FormFeedbackTypes from '../../../helpers/form/FormFieldFeedback/form-feedback-types';
import BannerAlert from '../../common/BannerAlert/BannerAlert';
import FormFieldFeedback from '../FormFieldFeedback/FormFieldFeedback';
import localStyles from './FormFeedback.module.pcss';

interface Props {
  /**
   * Feedback message props.
   */
  feedback: FormFeedbackTypes.FormFeedback;
  /**
   * Class name for the Form Feedback
   */
  className?: string;
}

/**
 *
 * Checks for the position of the form feedback and renders the feedback accordingly.
 *
 * @author Neha Anandpara
 */
const FormFeedback: ForwardRefExoticComponent<
  React.PropsWithChildren<Props> & RefAttributes<HTMLDivElement | HTMLSpanElement>
> = forwardRef<HTMLDivElement | HTMLSpanElement, Props>(function FormFeedbackForward(
  { feedback, className },
  ref
) {
  const { message, variant } = feedback;
  const cx = useClassNameMapper(localStyles);
  if (variant.type === FormFeedbackType.BANNER) {
    const { alertVariant } = variant;
    return (
      <BannerAlert
        alertMessage={message}
        alertVariant={alertVariant}
        testId={`FormFeedback.${feedback.variant.type}`}
        ref={ref}
      />
    );
  } else if (feedback.variant.type === FormFeedbackType.INLINE) {
    const { valid } = variant;
    return (
      <FormFieldFeedback
        message={message}
        valid={valid}
        className={cx(className, 'lia-text-style')}
      />
    );
  } else {
    return null;
  }
});

export default FormFeedback;
